export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/4bbae4aea16768e62ee2383bd068c544.jpg";